import { Selector, State } from "./types";
import { matchRequest } from "./utils";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveOccupancyRequestPending(
      from,
      to,
      granularity,
      filter,
      sort,
      size,
    ) {
      const state = getState();
      const index = matchRequest(
        state,
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      );
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.request.isPending : false;
    },
    isRetrieveOccupancyRequestSuccess(
      from,
      to,
      granularity,
      filter,
      sort,
      size,
    ) {
      const state = getState();
      const index = matchRequest(
        state,
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      );
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.request.isSuccessful : false;
    },
    isRetrieveOccupancyRequestFailure(
      from,
      to,
      granularity,
      filter,
      sort,
      size,
    ) {
      const state = getState();
      const index = matchRequest(
        state,
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      );
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.request.isFailure : false;
    },
    getOccupancyContent(from, to, granularity, filter, sort, size) {
      const state = getState();
      const index = matchRequest(
        state,
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      );
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.content : [];
    },
    getOccupancyCurrentPage(from, to, granularity, filter, sort, size) {
      const state = getState();
      const index = matchRequest(
        state,
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      );
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.currentPage : 0;
    },
    canLoadMoreOccupancy(from, to, granularity, filter, sort, size) {
      const state = getState();
      const index = matchRequest(
        state,
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      );
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.canLoadMore : true;
    },
    getOccupancyTotalElements(from, to, granularity, filter, sort, size) {
      const state = getState();
      const index = matchRequest(
        state,
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      );
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.totalElements : 0;
    },
  };
}

export { createSelector };
